import Vue from 'vue'
// import { dragscroll } from 'vue-dragscroll'
import Component from 'vue-class-component'
import { mapGetters } from 'vuex';

@Component
export class IsCollapseMixin extends Vue {
	isCollapse= false;
	window_width= window.innerWidth;
	window_height= window.innerHeight;
	
	handleResize() {
		if (window.innerWidth<1000){
			this.isCollapse = true;
		} else {
			this.isCollapse = false;
		}
		this.window_width = window.innerWidth;
		this.window_height = window.innerHeight;
	}

	isMobile() {
		if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			return true
		} else {
			return false
		}
	}

	toggleCollapse () {
		this.isCollapse = !this.isCollapse;
	}

	mounted() {
		window.addEventListener('resize', this.handleResize)
		this.handleResize();
	}

	destroyed() {
		window.removeEventListener('resize', this.handleResize)
	}
}

@Component({
	computed:{
		...mapGetters(['theme']),
	}
})
export class ThemeMixin extends Vue {
	isCollapse= false;
	theme_colors= {
		light: {menuBg: '#fff', headerBg: '#fff', menuColor: '#333',menuActive: '#111', back: '#f8f8fb', color: '#000'},
		dark: {menuBg: '#333', headerBg: '#333',  menuColor: '#aaa', menuActive: '#fff', back: '#222', color: '#fff'}
	};
}

// const draggable = {
// 	directives: {
// 		'dragscroll': dragscroll
// 	},
// }

// export {
// 	IsCollapseMixin,
// 	ThemeMixin,
// 	// draggable,
// };